module.exports = __webpack_public_path__ + "media/images/disivo_logo-b0b6e0c72192d05d85367ae8ae11611d.svg";